import React from "react";
import { Box, Switch, Typography } from "@mui/material";
import ReactCountryFlag from "react-country-flag";
import { useTranslation } from "react-i18next";
import { useStoredLanguage } from "@translations/useStoredLanguage";

const normalizeLanguage = (lng: string | undefined) => {
  if (!lng) return "de";
  return lng.toLowerCase().startsWith("en") ? "en" : "de";
};

export const LanguageSwitch = () => {
  const { setLanguage } = useStoredLanguage();
  const { t, i18n } = useTranslation();
  const current = normalizeLanguage(i18n.language);
  const isEn = current === "en";

  return (
    <Box mt={7.5}>
      <Typography
        variant="overline"
        color="textSecondary"
        textTransform="uppercase"
        mb={3.5}
        ml={2}
      >
        {t("settings.sidebar.language.title")}
      </Typography>
      <Box display="flex" alignItems="center" gap={1.5} ml={1.5}>
        <Box
          sx={{
            width: 24,
            height: 24,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          <ReactCountryFlag
            countryCode={isEn ? "GB" : "DE"}
            svg
            title={isEn ? "English" : "Deutsch"}
            style={{
              width: "22px",
              height: "16px",
              borderRadius: "2px",
            }}
          />
        </Box>
        <Switch
          checked={isEn}
          onChange={() => setLanguage(isEn ? "de" : "en")}
          color="primary"
        />
        <Typography
          color={isEn ? "textPrimary" : "textSecondary"}
          sx={{
            fontSize: "14px",
            lineHeight: "22px",
            width: 24,
            textAlign: "center",
          }}
        >
          {isEn ? "Eng" : "De"}
        </Typography>
      </Box>
    </Box>
  );
};
